var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"note-body"},[_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html:[$options.safeHtmlConfig]",value:(_vm.note.bodyHtml),expression:"note.bodyHtml",arg:_vm.$options.safeHtmlConfig}],staticClass:"note-text md",attrs:{"data-testid":"work-item-note-body"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }